import { render, staticRenderFns } from "./emailInfoList.vue?vue&type=template&id=0d10a24d&scoped=true"
import script from "./emailInfoList.vue?vue&type=script&lang=js"
export * from "./emailInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10a24d",
  null
  
)

export default component.exports